import React from "react";
import "./graphs.css";
import { COLORS } from "./utils";

export default function Legend({
    legendData,
    legandLabel = [],
}: {
    legendData: string[][];
    legandLabel?: string[];
}) {
    if (!legendData) return <></>;
    const containsLabels = legendData.length === legandLabel.length;
    return (
        <div className="legendContainer">
            {legendData.map((line, lineIndex) => (
                <div key={lineIndex} style={containsLabels ? { width: "75%" } : {}}>
                    {containsLabels ? (
                        <span className="legendLabel">{legandLabel[lineIndex] + ":"}</span>
                    ) : null}
                    <div className="legend">
                        {line.map((label, i) => (
                            <div
                                key={label}
                                style={{ background: COLORS[i] }}
                                className="legendBlock"
                            >
                                <span>{label}</span>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}
